import type { UA_AddUnitsData } from './UA.types'

export function UA_emptyAddUnitsData(): UA_AddUnitsData {
    return {
        targetUnitTypeId: null,
        unitListIdToAddUnitTo: null,
        orderedUnitTypes: [],
        displayUnitTypeId: null,
        filterUnitsLookup: null,
        filterUnitsByUnitTypeId: null,
        unitsLookup: null,
    }
}
